// @ts-nocheck

/* eslint-disable sonarjs/no-duplicate-string */
import pkg from '../package.json';

import { isAndroid } from './lib/useragent';
import { ApplicationPlatforms, ApplicationTypes } from './types/application';

const { isMobile, isEmbed, __STANDALONE__, __WEBHOSTS__, __SOCKETS__ } = window;

// Can't import the one from utils/index.js cause of circular dependencies. So this is a copy
const getQuerystringParam = (name) => {
  if (window !== undefined) {
    const match = new RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  }
};

const isWinabetLib = !!process.env.REACT_APP_LIB_ENV;
const appVhost = process.env.REACT_APP_VHOST;
const subDomain = appVhost || 'www';
const environment = process.env.REACT_APP_LIB_ENV || process.env.NODE_ENV;
const isEmbeddedForce = getQuerystringParam('forceEmbed') || false;
const isTest = environment === 'test';

const Client = {
  tracker: undefined,
  store: undefined,
  storeId: undefined,
  appVersion: undefined,
  bettingVersion: pkg.version,
  application: isMobile?.() && !isWinabetLib ? ApplicationTypes.MOBILE_BETTING : ApplicationTypes.SITE,
  platform: ApplicationPlatforms.WEB,
  embed: false,
};

if (!Client.tracker) {
  // On regarde en prio l'oid passé dans le redirect envoyé par le poker
  // Sinon, on regarde la fonction getTracker
  Client.tracker = getQuerystringParam('oid') ?? window.getTracker?.() ?? undefined;
}

if (!Client.store) {
  Client.store = getQuerystringParam('store') ?? window.getAppStore?.() ?? undefined;
}

if (!Client.storeId) {
  Client.storeId = getQuerystringParam('store_id') ?? window.getStoreId?.() ?? undefined;
}

if (!Client.appVersion) {
  Client.appVersion = getQuerystringParam('ver') ?? undefined;
}

const platform = getQuerystringParam('platform');
if (platform) {
  Client.platform = platform;
}

// On est en mode embedded si:
// - Build en mode STANDALONE (actuellement uniquement iOS)
// - On a une platform=ios|android
// - On a un param forceEmbed (historiquement utilisé lors de la redirection sur les grilles, legacy ?)
// - La fonction isEmbed() injéctée renvoie une valeure (legacy)
const isEmbedded =
  __STANDALONE__ ||
  [ApplicationPlatforms.IOS, ApplicationPlatforms.ANDROID].indexOf(Client.platform) !== -1 ||
  isEmbeddedForce ||
  isEmbed?.();

// Gestion de la retrocompatibilitée
// Si on est pas en mode lib (pour electron)
if (isEmbedded && !isWinabetLib) {
  console.log('[Native Mode]');
  // On va override les params qu'on peut override
  Client.platform = isAndroid ? ApplicationPlatforms.ANDROID : ApplicationPlatforms.IOS;
  Client.embed = true;
} else {
  if (!isTest) {
    console.log('[Web Mode]');
  }
}
if (!isTest) {
  console.log(JSON.stringify(Client, null, 2));
}

let ready = false;

export const fetchClientInfos = async (WinaAppPlugin) => {
  if (ready) {
    return;
  }

  const clientInfos = await WinaAppPlugin.getClientInfos();

  // On est en natif, on override les infos qu'on a
  if (clientInfos !== null) {
    Client.embed = true;
    if (clientInfos.platform) {
      Client.platform = clientInfos.platform;
    }
    if (clientInfos.app_version) {
      Client.appVersion = clientInfos.app_version;
    }
    if (clientInfos.store) {
      Client.store = clientInfos.store;
    }
    if (clientInfos.store_id) {
      Client.storeId = clientInfos.store_id;
    }
    if (clientInfos.oid) {
      Client.tracker = clientInfos.oid;
    }
  }
  ready = true;
};

/**
 * TARGET
 */

let domain = '';

const isDev = environment !== 'production';

if (isDev) {
  domain = '.dev';
}

const defaultWebHosts = {
  en: `https://${subDomain}${domain}.winamax.fr/en`,
  de: `https://${subDomain}${domain}.winamax.de`,
  it: `https://${subDomain}${domain}.winamax.it`,
  es: `https://${subDomain}${domain}.winamax.es`,
  fr: `https://${subDomain}${domain}.winamax.fr`,
  pt: `https://${subDomain}${domain}.winamax.pt`,
};

const defaultSockets = {
  ES: {
    host: `https://sports-eu-west-3${domain}.winamax.es`,
    path: '/uof-sports-server/socket.io',
  },
  FR: {
    host: `https://sports-eu-west-3${domain}.winamax.fr`,
    path: '/uof-sports-server/socket.io',
  },
  DE: {
    host: `https://sports-eu-west-3${domain}.winamax.de`,
    path: '/uof-sports-server/socket.io',
  },
  PT: {
    host: `https://sports-eu-west-3${domain}.winamax.pt`,
    path: '/uof-sports-server/socket.io',
  },
};

const staticHost = `https://s${domain}.winamax.fr`;

const webHosts = __WEBHOSTS__ || defaultWebHosts;

const linkHost = webHosts['fr']?.indexOf('.dev.') !== -1 ? `https://dev.winamax.link` : `https://winamax.link`;

const apiHostByLang = (lang) =>
  webHosts[lang]?.indexOf('.dev.') !== -1 ? `https://wapi.dev.winamax.${lang}` : `https://wapi.winamax.${lang}`;
const apiHosts = {
  en: apiHostByLang('fr'),
  de: apiHostByLang('fr'),
  it: apiHostByLang('fr'),
  es: apiHostByLang('es'),
  fr: apiHostByLang('fr'),
  pt: apiHostByLang('pt'),
};

export const Target = {
  __ENV__: environment,
  __API_HOSTS__: apiHosts,
  __LIBRARY__: isWinabetLib,
  __MOBILE__: Client.application === ApplicationTypes.MOBILE_BETTING,
  __EMBEDDED__: Client.embed,
  __STANDALONE__: __STANDALONE__ !== undefined ? __STANDALONE__ : true,
  __WEBHOSTS__: webHosts,
  __SOCKETS__: __SOCKETS__ || defaultSockets,
  __STATIC_HOST__: staticHost,
  __LINK_HOST__: linkHost,
  __TEST__: isTest,
};

if (!Target.__TEST__) {
  console.debug(`%c runtime | target / embed %O`, 'background: #616161; color: #fff;', {
    target: Target.__MOBILE__ ? 'mobile' : 'desktop',
    embed: Client.embed,
    standalone: Target.__STANDALONE__,
    webHosts: Target.__WEBHOSTS__,
    socketsByLicence: Target.__SOCKETS__,
    staticHost,
  });
}

export default Client;

export const isIOSEmbeddedAndStandalone =
  Client.embed && Target.__STANDALONE__ && Client.platform === ApplicationPlatforms.IOS;
